import SearchableSelect from './SearchableSelect';

export interface PickablePerson {
  id: string;
  displayName: string;
  email?: string | null;
}

interface Props {
  value: string[];
  onChange: (next: string[]) => void;
  /** Personen aus dem Adressbuch (Regel: Personen-Picker kommen aus dem Adressbuch). */
  persons: PickablePerson[];
  placeholder?: string;
  disabled?: boolean;
  /** Anker für Tests, wird an den Container gehängt. */
  testAnchor?: string;
}

/**
 * Chip-Mehrfachauswahl von Personen (Modul-ACL S2, 2026-10-14). Muster aus
 * bauberichte `TaskEditModal` (Hilfskräfte): gewählte Personen als Chips mit „×“,
 * darunter ein `SearchableSelect`, das nach der Auswahl wieder leer ist.
 */
export default function PersonMultiPicker(p: Props) {
  const byId = new Map(p.persons.map((x) => [x.id, x]));
  return (
    <div className="rounded bg-slate-800 border border-slate-700 p-2 space-y-2" data-test-anchor={p.testAnchor}>
      {p.value.length > 0 && (
        <div className="flex flex-wrap gap-1">
          {p.value.map((id) => (
            <span key={id} className="inline-flex items-center gap-1 px-2 py-0.5 rounded bg-slate-700 text-slate-100 text-xs">
              {byId.get(id)?.displayName ?? id.slice(0, 8)}
              {!p.disabled && (
                <button
                  type="button"
                  tabIndex={-1}
                  onClick={() => p.onChange(p.value.filter((x) => x !== id))}
                  className="text-slate-400 hover:text-rose-300"
                  aria-label="Person entfernen"
                >×</button>
              )}
            </span>
          ))}
        </div>
      )}
      {!p.disabled && (
        <SearchableSelect
          value={null}
          onChange={(id) => { if (id && !p.value.includes(id)) p.onChange([...p.value, id]); }}
          placeholder={p.placeholder ?? 'Person hinzufügen…'}
          options={p.persons
            .filter((x) => !p.value.includes(x.id))
            .map((x) => ({ id: x.id, label: x.displayName || x.email || x.id, searchableText: x.email ?? undefined, hint: x.email ?? undefined }))}
        />
      )}
    </div>
  );
}
